import React, { useEffect, useState, useRef, useMemo } from 'react'
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import JoditEditor from "jodit-react"
import { useHistory, Link  } from 'react-router-dom'
import api from '../components/api'
//import { dataTableRender } from '../components/functions'
import ModalBarraLateral from '../modals/barraLateral'
import ModalAnexo from '../modals/anexo'
import moment from 'moment'


const Pagina = (props) => {

    var [barraLateral_id, setBarraLateral_id] = useState()

    var [pagina_id, setPagina_id] = useState(props.match.params.pagina_id)
    var [identificacao, setIdentificacao] = useState('')
    var [dataCriacao, setDataCriacao] = useState()
    var [dataAtualizacao, setDataAtualizacao] = useState()
    var [atualizadoPor, setAtualizadoPor] = useState(sessionStorage.getItem('nome'))
    var [barraLateral, setBarraLateral] = useState(false)
  
    var [alias, setAlias] = useState('')
    var [texto, setTexto] = useState()
    var [ad_usr, setAd_usr] = useState(sessionStorage.getItem('us_codigo'))
    var [fixo, setFixo] = useState(false)

    const [rowSelection, setRowSelection] = useState({});
    var [conteudoBarraLateral, setConteudoBarraLateral] = useState([])
    const [totalConteudoBarraLateral, setTotalConteudoBarraLateral] = useState(0)
    var [conteudoAnexos, setConteudoAnexos] = useState([])
    const [totalAnexos, setTotalAnexos] = useState(0)

    

    var history = useHistory()

    const editor = useRef(null)
//    const [content, setContent] = useState('')


    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        height: 500,
        placeholder: 'Escreva aqui...',
      })



    


    function apagaAnexo() {

        
        //console.log(rowSelection, 'aqui')

        const arquivo_id = Object.keys(rowSelection)[0];

        //console.log(key, 'key aqui')

        if (arquivo_id == null) {


            window.toastr.error('Por favor, selecione um registro!')
            return false


        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    //console.log('apagar!')
                    api.delete(`paginaAnexo/${arquivo_id}/${ad_usr}`).then((result) => {

                        //console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            window.toastr.success('Apagado com sucesso!')
                            carregaAnexos()

                        }

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    function salvar() {

        var dataPost = {

            identificacao: identificacao,
            conteudo: texto,
            barraLateral: barraLateral,
            ad_usr: ad_usr,
            alias: alias,

        }


        if (identificacao == '') {


            window.toastr.error('<b>Identificação da página</b> não pode ficar em branco!')
            return false

        }


        //console.log(dataPost, pagina_id)

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    
                    if (!isNaN(pagina_id)) {


                        api.put(`pagina/${pagina_id}`, dataPost).then((result) => {
                            //console.log(result.data)
    
                            window.toastr.success('Salvo com sucesso!')
    
                        }).catch((err) => {
                            console.log(err.response)
                        })


                    } else {

                        //console.log('incluir')

                        api.post('pagina', dataPost).then((result) => {

                            var data = result.data[0]

                            if (data) {

                                setPagina_id(data.pagina_id)
                                history.push(`/Pagina/${data.pagina_id}`)
                                window.toastr.success('Salvo com sucesso!')

                            }

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }

                    

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    async function carregaPagina() {


        await api.get(`pagina/${pagina_id}`).then((result) => {

            //console.log(result.data)

            var data = result.data[0]

            if (data) {

                setPagina_id(data.pagina_id)
                setIdentificacao(data.identificacao)
                setDataCriacao(data.dataCriacao)
                setDataAtualizacao(data.dataAtualizacao)
                setTexto(data.conteudo)
                setAtualizadoPor(data.atualizadoPor)
                setBarraLateral(data.barraLateral)
                setAlias(data.alias ? data.alias : '')
                setFixo(data.fixo)

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function apagar() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    //console.log('apagar!')
                    api.delete(`pagina/${pagina_id}`).then((result) => {

                        console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            window.toastr.success('Apagado com sucesso!')
                            history.push('/Paginas')

                        }

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }



                                        <div className="table-responsive">
                                            <table id="tabelaAnexos" className="table table-bordered table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '220px'}}>Arquivo</th>
                                                        <th style={{ width: '220px'}}><center>Incluso em</center></th>
                                                        <th style={{ width: '120px'}}><center>Por</center></th>
                                                        <th><center>Link</center></th>
                                                        <th style={{ width: '20px'}}><center>&nbsp;</center></th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {conteudoAnexos}
                                                    
                                                </tbody>
                                                
                                            </table>
                                        
                                        </div>

    

    const columnsAnexos = useMemo(
        () => [
            {
            accessorKey: 'nomeArquivo', //access nested data with dot notation
            header: 'Arquivo',
            },
            {
            accessorKey: 'ad_new',
            header: 'Incluso em',
            accessorFn: (row) => {
              // Divide a data da hora
              const [datePart, timePart] = row.ad_new.split(' ');
              const [day, month, year] = datePart.split('/');
          
              // Junta no formato ISO reconhecido pelo JavaScript
              return new Date(`${year}-${month}-${day}T${timePart}`);
            },
            Cell: ({ cell }) => {
              const date = cell.getValue();
              return date instanceof Date && !isNaN(date)
                ? moment(date).format('DD/MM/YYYY HH:mm:ss')
                : '';
            },
            sortingFn: 'datetime',
            muiTableHeadCellProps: {
              align: 'center',
            },
            muiTableBodyCellProps: {
              align: 'center',
            },
          },
            {
            accessorKey: 'us_nome',
            header: 'Por',
            },
             {
            accessorKey: 'linkArquivo',
            header: 'Link',
            },
            

        ],
        [],
        );

    



    async function carregaAnexos() {

        await api.get(`paginaAnexo/${pagina_id}`).then((result) => {

            //console.log(result.data)
            setConteudoAnexos(result.data)
            setTotalAnexos(result.data.length)

            /*

            setConteudoAnexos(result.data.map((rs) =>
            
                <tr>
                    <td style={{ cursor: 'pointer'}} onClick={() => window.open(rs.linkArquivo)}>
                        <center>
                        {rs.nomeArquivo}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.ad_new}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.us_nome}
                        </center>
                    </td>
                    <td >
                        <center>
                        {rs.linkArquivo}
                        </center>
                    </td>
                    <td>
                        <center>
                        <Link onClick={() => apagaAnexo(rs.arquivo_id)}>[Apagar]</Link>
                        </center>
                    </td>
                </tr>
            
            
            ))

            dataTableRender('tabelaAnexos')
            */

        }).catch((err) => {

            console.log(err.response)

        })

        

    }



    const columnsBarraLateral = useMemo(
        () => [
            {
            accessorKey: 'titulo', //access nested data with dot notation
            header: 'Título',
            },
            {
            accessorKey: 'topico',
            header: 'Tópico',
            },
            {
            accessorKey: 'dataAtualizacao',
            header: 'Data Atualização',
            },
            

        ],
        [],
        );

    

    async function carregaBarraLateral() {

        //console.log('!!')

        api.get(`barraLateral/${pagina_id}`).then((result) => {

            //console.log(result.data, '!!')
            setConteudoBarraLateral(result.data)
            setTotalConteudoBarraLateral(result.data.length)

            /*
            setConteudoBarraLateral(result.data.map((rs) =>

                <tr style={{ cursor: 'pointer'}} data-toggle="modal" data-target="#modalBarraLateral" onClick={() => setBarraLateral_id(rs.barraLateral_id)}>
                    <td>{rs.titulo}</td>
                    <td><center>{rs.topico}</center></td>
                    <td><center>{rs.dataAtualizacao}</center></td>
                    <td></td>
                </tr>
            
            ))

            dataTableRender('tabelaBarraLateral')
            */

            
        }).catch((err) => {

            console.log(err.response)

        })

    }

    

    async function verificaPermissao() {


        if (sessionStorage.getItem('permPaginas') != 'true') {

            history.push('/')

        }


    }


    useEffect(() => {
        
        verificaPermissao()
        carregaPagina()
        carregaBarraLateral()
        carregaAnexos()

    }, [pagina_id])
        

    return (

        <div>

            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-home'></i>
                </div>
                <div class='header-title'>
                    <h1>P&aacute;ginas e Conteúdos</h1>
                    <small>Administração</small>
                    
                </div>
            </div>

            <div class="row">

                <div class="col-md-9">
                    <div class="form-group">
                        <label>Identificação da página</label>
                        <input type="text" class="form-control" placeholder="" value={identificacao} onChange={event => setIdentificacao(event.target.value)} disabled={fixo ? true : false} />
                                        
                    </div>
                </div>


                <div class="col-md-3">
                    <div class="form-group">
                        <label>Barra lateral</label>
                        <select class="form-control" placeholder="" value={barraLateral} onChange={event => setBarraLateral(event.target.value)} disabled={ !isNaN(pagina_id) ? false : true}>
                            <option value={false}>Não</option>
                            <option value={true}>Sim</option>                            
                        </select>
                        
                                      
                    </div>
                </div>

               
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Criada em</label>
                        <input type="text" class="form-control" placeholder="" value={dataCriacao} onChange={event => setDataCriacao(event.target.value)} disabled />
                                        
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label>Atualizada em</label>
                        <input type="text" class="form-control" placeholder="" value={dataAtualizacao} onChange={event => setDataAtualizacao(event.target.value)} disabled />
                                        
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label>Por</label>
                        <input type="text" class="form-control" placeholder="" value={atualizadoPor} onChange={event => setAtualizadoPor(event.target.value)} disabled />
                                        
                    </div>
                </div>


                <div class="col-md-12" style={{ display: fixo ? 'none' : 'table-row'}}>
                    <div class="form-group">
                        
                        <label>Alias</label>
                        <input type="text" class="form-control" placeholder="" value={alias} onChange={event => setAlias(event.target.value)}  disabled={fixo ? true : false} />
                                        
                    </div>
                </div>
                <div class="col-md-12" style={{ display: fixo ? 'none' : 'table-row'}}>
                    <div class="form-group">
                        <label>Link com alias</label>
                        <input type="text" class="form-control" placeholder="" value={`https://hospitaissaudaveis.org/!/${alias}`} disabled />
                                        
                    </div>
                </div>
                <div class="col-md-12" style={{ display: fixo ? 'none' : 'table-row'}}>
                    <div class="form-group">
                        <label>Link sem alias</label>
                        <input type="text" class="form-control" placeholder="" value={ pagina_id != 'Nova' ? `https://hospitaissaudaveis.org/!/${pagina_id}` : '' } disabled />
                                        
                    </div>
                </div>




                <div class="col-sm-12">
                    


                    <ul class="nav nav-tabs">
                            <li class="active"><a href="#tab1" data-toggle="tab">Corpo da página</a></li>
                            <li style={{ display: !barraLateral ? 'none' : 'block'}} ><a href="#tab2" data-toggle="tab">Barra lateral ({totalConteudoBarraLateral})</a></li>
                            <li style={{ display: pagina_id ? 'block' : 'none'}} ><a href="#tab3" data-toggle="tab">Anexos ({totalAnexos})</a></li>
                            
                        </ul>
                        
                        <div class="tab-content">
                            <div class="tab-pane fade in active" id="tab1">
                                <div class="panel-body">
                                        
                                

                                <div class="col-md-12">

                                <JoditEditor
                                    ref={editor}
                                    value={texto}
                                    config={config}
                                    tabIndex={1}
                                    onChange={content => setTexto(content)}
                                    />

                                    </div>



                                </div>

                            </div>
                            <div class="tab-pane fade in" id="tab2" >
                                <div class="panel-body">

                                    <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalBarraLateral" onClick={() => setBarraLateral_id()}>+ Novo</button>
                                    <br/><br/><br/>



                                    <MaterialReactTable 
                                                                    
                                        columns={columnsBarraLateral} 
                                        data={conteudoBarraLateral} 
                                        localization={MRT_Localization_PT_BR}
                                        //rowsPerPage={20}
                                        //options={options}
                                        initialState={{ 
                                            density: 'compact',
                                            sorting: [
                                                {
                                                    id: 'ad_new', //sort by age by default on page load
                                                    desc: true,
                                                },
                                                
                                                ],
                                            }}
                                        muiTableHeadCellProps={{
                                            //easier way to create media queries, no useMediaQuery hook needed.
                                            sx: {
                                            fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                            },
                                            },
                                        }}
                                        muiTableBodyCellProps={{
                                            sx: {
                                                fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                                },
                                            },
                                        }}
                                        muiTableBodyRowProps={({ row }) => ({
                                        onClick: (event) => {
                                            //console.info(event, row.original.usuario_id);
                                            //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                            window.$('#modalBarraLateral').modal('show');setBarraLateral_id(row.original.barraLateral_id)
                                            //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                    
                                        },
                                        sx: {
                                            cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                        },
                                        })}
                                    />




                                </div>

                            </div>
                            <div class="tab-pane fade in" id="tab3" >
                                <div class="panel-body">

                                    <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalAnexo" >+ Novo</button>&nbsp;
                                    <button type="button" class="btn btn-danger" onClick={() => apagaAnexo()}>Apagar selecionado</button>
                                    <br/><br/><br/>


                                    <MaterialReactTable 
                                                                    
                                        columns={columnsAnexos} 
                                        data={conteudoAnexos} 
                                        localization={MRT_Localization_PT_BR}


                                            enableRowSelection={true}
                                            enableMultiRowSelection={false}
                                            //getRowId={(row) => row.inscricao_id}
                                            //onRowSelectionChange={setRowSelection}
                                            //state={ rowSelection }
                                            getRowId={(originalRow) => originalRow.arquivo_id}
                                            onRowSelectionChange={setRowSelection}
                                            state={{ rowSelection }}

                                            
                                        //rowsPerPage={20}
                                        //options={options}
                                        initialState={{ 
                                            density: 'compact',
                                            sorting: [
                                                {
                                                    id: 'ad_new', //sort by age by default on page load
                                                    desc: true,
                                                },
                                                
                                                ],
                                            }}
                                        muiTableHeadCellProps={{
                                            //easier way to create media queries, no useMediaQuery hook needed.
                                            sx: {
                                            fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                            },
                                            },
                                        }}
                                        muiTableBodyCellProps={{
                                            sx: {
                                                fontSize: {
                                                xs: '8px',
                                                sm: '9px',
                                                md: '10px',
                                                lg: '11px',
                                                xl: '12px',
                                                },
                                            },
                                        }}
                                        muiTableBodyRowProps={({ row }) => ({
                                        onClick: (event) => {
                                            //console.info(event, row.original.usuario_id);
                                            //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                            //window.$('#modalAnexo').modal('show');setPagina_id(row.original.pagina_id)
                                            //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                    
                                        },
                                        sx: {
                                            cursor: 'auto', //you might want to change the cursor too when adding an onClick
                                        },
                                        })}
                                    />
                                        

                                </div>

                            </div>
                        </div>
                    

                </div>



                <div class="col-md-12">

                    <br/>
                                    
                    <button type="button" class="btn btn-info" onClick={() => history.push('/Paginas')}>Voltar</button>&nbsp;
                    <button type="button" class="btn btn-danger" onClick={() => apagar()} style={{ display: !isNaN(pagina_id) && fixo != true ? 'table-row' : 'none' }}>Apagar</button>&nbsp;
                    <button type="button" class="btn btn-primary" onClick={() => salvar()}>Salvar</button>
                </div>

            </div>


            <ModalBarraLateral barraLateral_id={barraLateral_id} carregaBarraLateral={carregaBarraLateral} pagina_id={pagina_id} />
            <ModalAnexo pagina_id={pagina_id} />

        </div>

    )


}

export default Pagina